import React from 'react';
import S from '../../UmbracoForm.styles';
const TitleAndDescription = ({ field }) => {
    return (React.createElement(S.Field, null,
        field.settings?.caption && (React.createElement(S.FieldTitle, { as: getHeadingTag(), "data-heading": getHeadingTag() }, field.settings.caption)),
        field.settings?.bodyText && (React.createElement(S.FieldDescription, { dangerouslySetInnerHTML: { __html: field.settings.bodyText } }))));
    function getHeadingTag() {
        switch (field.settings?.captionTag) {
            case 'h1':
                return 'h1';
            case 'h2':
                return 'h2';
            case 'h3':
                return 'h3';
            case 'h4':
                return 'h4';
            case 'h5':
                return 'h5';
            case 'h6':
                return 'h6';
            default:
            case null:
            case undefined:
                return 'h2';
        }
    }
};
TitleAndDescription.displayName = 'TitleAndDescription';
export default TitleAndDescription;
